import _ from 'lodash';
import { Option } from './utilityTypes';

type Mapper<T, R> = (x: NonNullable<T>) => NonNullable<R>;

const map = <T, R>(
    mapper: Mapper<T, R>,
    option: Option<T>
): Option<NonNullable<R>> => {
    return option ? mapper(option as NonNullable<T>) : undefined;
};

type MapL = <T, R>(
    mapper: Mapper<T, R>
) => (option: Option<T>) => Option<NonNullable<R>>;

type MapR = <T, R>(
    option: Option<T>
) => (mapper: Mapper<T, R>) => Option<NonNullable<R>>;

// Names may not be straightforward
const mapL: MapL = _.curry(map);

const mapR: MapR = _.curryRight(map);

const toArray = <T>(option: Option<T>): [T] | [] => (option ? [option] : []);

export default { map, mapR, mapL, toArray };
export type { Option };
